/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Peter Brunton Theme Customisations Feb 2021 */
(() => {
 
  const cartBtns = document.querySelectorAll(".AddToCart");
  const optionBtns = document.querySelectorAll(".SizeSwatch");
  const cartDrawerBtn = document.querySelector("a[href='/cart'][data-action='open-drawer']");
  const cartDrawer = document.querySelector("#sidebar-cart");

  window.Spotlight= {
    cartDrawer : document.querySelector(".Cart.Drawer__Content"),
    cartBtns : document.querySelectorAll(".AddToCart"),
    productFormCartBtn : document.querySelector(".ProductForm__AddToCart"),
    upsellCartBtn : document.querySelector(".AddToCartUpsell"),
    upsellCheck : document.querySelector("#AddToCart-sync"),
    syncUpsellAddToCart : () => {
      window.Spotlight.productFormCartBtn.addEventListener('click', function() {
        if(window.Spotlight.upsellCheck.checked == true) {
          setTimeout(() => { 
            let varId = window.Spotlight.upsellCartBtn.getAttribute("data-var_id");
            let varQty = 1;
            let formData = {
             'items': [{
              'id': varId.toString(),
              'quantity': varQty
              }]
            };
            fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: varId,
                  quantity: varQty
                }
              }));
              if (window.Spotlight.cartDrawer.getAttribute("aria-hidden") == "true") {
                window.Spotlight.Cart.sidebarDrawer.open();
              }
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }, 500);
        }
      });
    },
    fadeOut : (el) => {
      el.style.opacity = 1;
      (function fade() {
        if ((el.style.opacity -= .1) <= 0) {
          el.style.display = "none";
        } else {
          requestAnimationFrame(fade);
        }
      })();
    },
    fadeIn : (el, display) => {
      el.style.opacity = 0;
      el.style.display = display || "block";
      (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += .1) >= 1)) {
          el.style.opacity = val;
          requestAnimationFrame(fade);
        }
      })();
    },
    productFormSticky : document.querySelector(".ProductFormSticky"),
    productAreaHeight : document.querySelector(".Product__Wrapper"),
    scrollPos : 0,
    activateStickyProductForm : () => {
      let windowY = window.scrollY;
      if (windowY < window.Spotlight.scrollPos) {  // Scrolling UP
        if(windowY < window.Spotlight.productAreaHeight) {         
          if(window.Spotlight.productFormSticky.classList.contains('u--fade-in')) {
            window.Spotlight.productFormSticky.classList.add('u--fade-out');
    		window.Spotlight.productFormSticky.classList.remove('u--fade-in');
            window.Spotlight.productFormSticky.classList.remove('u--active');
            setTimeout(() => { window.Spotlight.productFormSticky.classList.add('u--hide')}, 2000);
          }
        }
      } else {  // Scrolling DOWN
        if(windowY > window.Spotlight.productAreaHeight) {
          if(window.Spotlight.productFormSticky.classList.contains('u--hide')) {
            window.Spotlight.productFormSticky.classList.add('u--fade-in');
            window.Spotlight.productFormSticky.classList.remove('u--fade-out');
            window.Spotlight.productFormSticky.classList.remove('u--hide');
            setTimeout(() => { window.Spotlight.productFormSticky.classList.add('u--active')}, 2000);
          }
        }
      }
      window.Spotlight.scrollPos = windowY;
    },
    debounce : (func, wait = 10, immediate = true) => {
      let timeout;
      return function() {
        let context = this, args = arguments;
        let later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    identifyPositionOnScroll : () => {
      window.addEventListener('scroll', window.Spotlight.debounce(window.Spotlight.activateStickyProductForm))
    }
  }

  if(window.Spotlight.upsellCheck) {
    window.Spotlight.syncUpsellAddToCart();
  }
  
  if(window.Spotlight.productFormSticky) {
    window.Spotlight.productAreaHeight = window.Spotlight.productAreaHeight.clientHeight - 1000;
    window.Spotlight.identifyPositionOnScroll();
  }

  /* Site wide add to cart functionality */
  cartBtns.forEach(cartBtn => {
    cartBtn.addEventListener("click", function(e) {
      e.preventDefault();
      let varId = this.getAttribute("data-var_id");
      let varQty = this.getAttribute("data-var_qty") || 1;
      let formData = {
       'items': [{
        'id': varId,
        'quantity': varQty
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        if (cartDrawer.getAttribute("aria-hidden") == "true") {
          window.spotlight.cart.sidebarDrawer.open();
          //cartDrawerBtn.click();
        }
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });

  /* Site wide variant selection to update variant id to add to cart button */

  const removedSelected = () => {
    optionBtns.forEach(optionBtn => {
      if (optionBtn.classList.contains("selected")) {
        optionBtn.classList.remove("selected")
      }
    });
  }

  optionBtns.forEach(optionBtn => {
    optionBtn.addEventListener("click", (e) => {

      let currentProduct = optionBtn.closest("[data-product-id]");
      let currentProductId = currentProduct.getAttribute("data-product-id")

      removedSelected();
      e.target.classList.add("selected");

      let optionPosition = e.target.getAttribute('data-option-position');
      let optionValue = e.target.getAttribute('data-option-value');

      let selectedOption1;
      let selectedOption2;
      let selectedOption3;
      let option1;
      let option2;
      let option3;
      let hiddenVariantSelectorId = "product-select-" + currentProductId;   
      let hiddenVariantSelector = document.getElementById(hiddenVariantSelectorId);
      let variantId;

      if (currentProduct.querySelector(".selected[data-option-position='option-1']")) {
      selectedOption1 = currentProduct.querySelector(".selected[data-option-position='option-1']").getAttribute('data-option-value');
      }
      if (currentProduct.querySelector(".selected[data-option-position='option-2']")) {
        selectedOption2 = currentProduct.querySelector(".selected[data-option-position='option-2']").getAttribute('data-option-value');
      }
      if (currentProduct.querySelector(".selected[data-option-position='option-3']")) {
        selectedOption3 = currentProduct.querySelector(".selected[data-option-position='option-3']").getAttribute('data-option-value');
      }

      if (e.target.getAttribute('data-option-position') === "option-1" ){
        option1 = e.target.getAttribute('data-option-value');
      } else if (e.target.getAttribute('data-option-position') === "option-2" ){
        option2 = e.target.getAttribute('data-option-value');
      } else if (e.target.getAttribute('data-option-position') === "option-3" ){
        option3 = e.target.getAttribute('data-option-value');
      }

      if (selectedOption3 != null && selectedOption2 != null && selectedOption1 != null) {
        if (option1 === selectedOption1 && option2 === selectedOption2 && option3 === selectedOption3) {
          variantId = hiddenVariantSelector.querySelector("[data-variant-option1="+ option1 +"][data-variant-option1="+ option2 +"][data-variant-option1="+ option3 +"]").getAttribute('value');
        } 
      } else if (selectedOption2 != null && selectedOption1 != null) {
        if (option1 === selectedOption1 && option2 === selectedOption2) {
          variantId = hiddenVariantSelector.querySelector("[data-variant-option1="+ option1 +"][data-variant-option1="+ option2 +"]").getAttribute('value');
        }
      } else if (selectedOption1 != null) {
        if ( option1 === selectedOption1) {
          variantId = hiddenVariantSelector.querySelector("[data-variant-option1="+ option1 +"]").getAttribute('value');
        }
      }
      currentProduct.closest(".ProductFormSw").querySelector(".AddToCart").setAttribute("data-var_id", variantId, "data-add-to-cart", variantId);
    });
  });

  
window.onload = function() {
    
    /* Product Rollover, video autoplay on hover (2nd media item needs to be video) */
	const videosHover = document.querySelectorAll(".ProductItem__ImageWrapper--withAlternateVideo");
    
    [].forEach.call(videosHover, function(video) {
      // do whatever
      const videoContainerHeight = video.clientHeight;
      video.addEventListener("mouseover", playVideo, false);
      video.addEventListener("mouseout", pauseVideo, false);
    });

    function playVideo() {
      this.querySelector('video').setAttribute("loop", true);
	  this.querySelector('video').play();
    }

    function pauseVideo() {  
      this.querySelector('video').pause();
    }
    
    /* Move Chat icon to the left */
    setTimeout(function(){ 
      const chatBot = document.querySelector("#kustomer-ui-sdk-iframe");
      chatBot.style.cssText = "border: 0px; width: 70px; height: 70px; position: fixed; bottom: 50px; right: auto; z-index: 2147483000; transition: none 0s ease 0s; left: 0;";
    }, 2000);
}
  
/* Make all product grid items equal height */

  
window.addEventListener('DOMContentLoaded', (event) => {
  
  console.log('DOM fully loaded and parsed');

  var tabs = document.querySelectorAll('.TabList__Item');
  
  function sameHeights () {

    var nodeList = document.querySelectorAll('.ProductList .ProductItem__Wrapper');
    var elems = [].slice.call(nodeList);
    console.log(JSON.stringify(nodeList))

    var tallest = Math.max.apply(Math, elems.map(function(elem, index) {
      elem.style.minHeight = ''; // clean first
      return elem.offsetHeight;
    }));

    elems.forEach(function(elem, index, arr){ 
      elem.style.minHeight = tallest + 'px';
    });

  }

  var resized = true;
  var timeout = null;

  var refresh = function(){
    if(resized) {
      requestAnimationFrame(sameHeights);
    }
      clearTimeout(timeout);
      timeout = setTimeout( refresh, 100);
    resized = false;
  };
  
  tabs.forEach(function(tab, index, arr){
    this.addEventListener('click', function() { 
      console.log("tab clicked refreshing sameheight");
      setTimeout(sameHeights, 1000);
    }, false);
  });

  window.addEventListener('resize', function() { resized = true; });

  refresh();

});

  /* Fix Scroll on Mini Cart Suggestions */
var src = document.getElementsByClassName("mini-cart-upsell")[0];
var clientY;

src.addEventListener('touchstart', function(e) {
  clientY = e.touches[0].clientY;
}, false);

src.addEventListener('touchend', function(e) {
  var deltaY;
  var src = document.getElementsByClassName("mini-cart-upsell")[0];
  // Compute the change in X and Y coordinates.
  // The first touch point in the changedTouches
  // list is the touch point that was just removed from the surface.
  deltaY = e.changedTouches[0].clientY - clientY;
  var src = document.getElementsByClassName("mini-cart-upsell")[0];
  src.scroll(0,src.scrollTop-(deltaY*2));
  // Process the data ...
}, false);

/* Change text on AfterPay */
function afterPayText(){
  var afterPay =  document.getElementsByClassName('afterpay-link-inner')[0]
  if (afterPay != null) {
    afterPay.innerHTML = "Learn more";  
  } 
  else {
  setTimeout(afterPayText,1000);
  }
}

afterPayText()  


function getParentContainer(nodeList) {
  var uniqueCollections = []
  var sortedCollection = []
  
  for ( var x = 0 ; x < nodeList.length ; x++ ) {
    var container = nodeList[x].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    if ( !uniqueCollections.includes(container) && container != "undefined" ) {
      uniqueCollections.push(nodeList[x].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode);
      sortedCollection[sortedCollection.length] = [nodeList[x]]

    }
    }
  for (var x = 0; x < nodeList.length ; x++) {
  	var currentNode = nodeList[x]
    for (var y = 0; y < uniqueCollections.length ; y++) {
      var currentCollection = uniqueCollections[y];
      if (uniqueCollections[y].contains(currentNode) && !sortedCollection[y].includes(nodeList[x])){
        sortedCollection[y].push(currentNode);
        }     
  	}
  }

  
  return sortedCollection;
}
  
  
})();


